import { useEffect } from 'react';

/**
 * RussianSocialBar - Adsterra Social Bar ad format for mobile responsive visitors from Russia.
 *
 * Adsterra Tag:
 * <script data-cfasync="false" src="https://bauval.org/14/8554e116e3b211429aa4cb1e23f5f3c3"></script>
 *
 * Requirements:
 * 1. Only loads for visitors originating from Russia (controlled by isRussia in parent App.jsx).
 * 2. Only loads for mobile responsive view (viewport width <= 768px).
 * 3. Prevents duplicate script injection.
 * 4. Safe for SSR environments (Node.js / Firebase Functions).
 */
const RussianSocialBar = () => {
    useEffect(() => {
        if (typeof window === 'undefined' || typeof document === 'undefined') return;

        const SOCIAL_BAR_SRC = 'https://bauval.org/14/8554e116e3b211429aa4cb1e23f5f3c3';
        const SCRIPT_ID = 'adsterra-social-bar-ru';

        const isMobileView = () => {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0;
            return width <= 768;
        };

        const injectSocialBarScript = () => {
            if (document.getElementById(SCRIPT_ID) || document.querySelector(`script[src*="8554e116e3b211429aa4cb1e23f5f3c3"]`)) {
                return;
            }

            const script = document.createElement('script');
            script.id = SCRIPT_ID;
            script.type = 'text/javascript';
            script.src = SOCIAL_BAR_SRC;
            script.setAttribute('data-cfasync', 'false');
            script.async = true;
            (document.body || document.head).appendChild(script);
        };

        if (isMobileView()) {
            injectSocialBarScript();
        } else {
            // Listen for resize in case viewport changes to mobile (e.g. device orientation change, DevTools responsive mode)
            const handleResize = () => {
                if (isMobileView()) {
                    injectSocialBarScript();
                    window.removeEventListener('resize', handleResize);
                }
            };
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }
    }, []);

    return null;
};

export default RussianSocialBar;
